module.exports = __webpack_public_path__ + "static/media/Updates.8d077063.png";